/*
 * --------------------------------------------
 * map-common.js
 * --------------------------------------------
 *
 * Copyright (c) 2013 MyVirtualMission - http://myvirtualmission.com
 *
*/

window.maxIconNumber = (iconNumber) => {
	iconNumber = iconNumber + 1;

	if (iconNumber > 26) {
		iconNumber = 'plus';
	}
	else if (iconNumber < 1) {
		iconNumber = 1;
	}

	return iconNumber;
}


window.resizeMap = () => {
	$('div.gm-style button[title="Toggle fullscreen view"]').trigger('click');
}

window.refreshZoom = () => {
	newZoomLevel = map.getZoom();

	if (newZoomLevel != zoomLevel) {
		zoomLevel = newZoomLevel;
		if (zoomLevel < 20) {
			zoomLevel = zoomLevel + 1;
			$('#map_zoom_level').val(zoomLevel);
		}
		else if (zoomLevel > 2) {
			map.setZoom(zoomLevel - 1);
			zoomLevel = zoomLevel - 1;
			$('#map_zoom_level').val(zoomLevel);
		}	
	}
	
}

window.getDistanceFromLatLngInKm = (lat1,lng1,lat2,lng2) => {
  //var R = 6371; // Radius of the earth in km
  var R = 6378.137;
  var dLat = deg2rad(lat2-lat1);  // deg2rad below
  var dLon = deg2rad(lng2-lng1); 
  var a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * 
    Math.sin(dLon/2) * Math.sin(dLon/2)
    ; 
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
  var d = R * c; // Distance in km

  return d;
}

window.deg2rad = (deg) => {
  return deg * (Math.PI/180)
}


window.parseDistanceBetweenPercentage = (dbp) => {
	dbp = dbp.toFixed(2);

	if (dbp > 1) {
		dbp = 1;
	}
	else if (dbp < 0) {
		dbp = 0;
	}

	return dbp;
}

window.makeInfoWindowEvent = (map, infowindow, contentString, marker) => {
	google.maps.event.addListener(marker, 'click', function() {
		infowindow.setContent(contentString);
		infowindow.open(map, marker);
	});
}

window.searchLocation = (address) => {
	geocoder.geocode( { 'address': address }, function(results, status) {
		if (status == google.maps.GeocoderStatus.OK) {
			map.setCenter(results[0].geometry.location);

			/*var bounds = results[0].geometry.bounds;

			if (typeof bounds != 'undefined') {
				map.fitBounds(bounds);

				zoomLevel = map.getZoom();
			}

			console.log('zoom level: '+zoomLevel);*/

			var bounds = new google.maps.LatLngBounds(
			    results[0].geometry.viewport.getSouthWest(), 
			    results[0].geometry.viewport.getNorthEast()
			);

			map.fitBounds(bounds);

			zoomLevel = map.getZoom();
		}
	});
}

window.zoomMapToLevel = (zlevel) => {
	zoomLevel = parseInt(zlevel);
	map.setZoom(zoomLevel);
	$('#map_zoom_level').val(zoomLevel);
}

window.switchStreetview = (customLat,customLng,noStreetview) => {
	var panorama = map.getStreetView();

	var dist = 15; // < 50 metres will be nearest, 10-15 seems happy medium though..
	var targetLatLng = getTargetLatLng(customLat,customLng);

	if (panorama.getVisible() == true) {
		panorama.setVisible(false);

		if ($('a#viewfullscreenmap').length > 0) {
			var viewFullscreenMapHref = $('a#viewfullscreenmap').attr('data-basehref');
			$('a#viewfullscreenmap').attr('href',viewFullscreenMapHref);
		}

		$('#enable-streetview').text('Show me on Street View');

		return false;
	}
	else if (noStreetview) {
		zoomToUserLocation(targetLatLng);
		return;
	}
	else {
		var service = new google.maps.StreetViewService; 
		service.getPanoramaByLocation(targetLatLng, dist, function(panoData){
			if (panoData != null) {
				if (panoData.links != null) {
					service.getPanoramaById(panoData.links[0].pano, function(linkPanoData) {
				    	initStreetview(panorama,linkPanoData.location.latLng,panoData.links[1].heading);
					});
				}
				else {
					initStreetview(panorama,panoData.location.latLng);
				}
			}
			else {
				zoomToUserLocation(targetLatLng);

				$('#zoom-position').addClass('zoomedin');
				if ($('#zoom-position').hasClass('app-zoom-position')) {
					$('#zoom-position').html('Reset&nbsp;zoom<br />position');
				}
				else {
					$('#zoom-position').html('Reset zoom position');
				}

				$('#enable-streetview').remove();
				$('#enable-streetview-msg').html('<p id="enable-streetview-msg" class="text-danger text-center mt-3">Unfortunately your current position does not have a Google Street View available.</p>');
			}
		}); 	
	}
}

window.zoomToUserLocation = (targetLatLng) => {
	map.setCenter(targetLatLng);
	zoomMapToLevel(15);
}
window.switchMapType = (type) => {
	map.setMapTypeId(type);
}


window.initStreetview = (panorama,svLatLng,svHeading) => {
    //var panorama = map.getStreetView();
    panorama.setPosition(svLatLng);
    panorama.setVisible(true);
    panorama.setZoom(0);

    panorama.setPov({heading:svHeading, pitch:-8});

	if ($('a#viewfullscreenmap').length > 0) {
    	var viewFullscreenMapHref = $('a#viewfullscreenmap').attr('data-basehref');
		$('a#viewfullscreenmap').attr('href',viewFullscreenMapHref+'?streetview=1&lat='+svLatLng.lat()+'&lng='+svLatLng.lng()+'&heading='+svHeading);
	}

	map.setCenter(svLatLng);
	zoomMapToLevel(15);

	$('#enable-streetview').text('Close Street View');

	$('#zoom-position').addClass('zoomedin');
	if ($('#zoom-position').hasClass('app-zoom-position')) {
		$('#zoom-position').html('Reset&nbsp;zoom<br />position');
	}
	else {
		$('#zoom-position').html('Reset zoom position');
	}
}

window.zoomPosition = (customLat,customLng) => {
	var panorama = map.getStreetView();

	if (panorama.getVisible() == true) {
		panorama.setVisible(false);

		if ($('a#viewfullscreenmap').length > 0) {
			var viewFullscreenMapHref = $('a#viewfullscreenmap').attr('data-basehref');
			$('a#viewfullscreenmap').attr('href',viewFullscreenMapHref);
		}

		$('#enable-streetview').text('Show me on Street View');
	}

	var targetLatLng = getTargetLatLng(customLat,customLng);

	map.setCenter(targetLatLng);
	zoomMapToLevel(15);

	$('#zoom-position').addClass('zoomedin');
	if ($('#zoom-position').hasClass('app-zoom-position')) {
		$('#zoom-position').html('Reset&nbsp;zoom<br />position');
	}
	else {
		$('#zoom-position').html('Reset zoom position');
	}
}

window.resetZoomPosition = () => {
	var panorama = map.getStreetView();

	if (panorama.getVisible() == true) {
		panorama.setVisible(false);

		if ($('a#viewfullscreenmap').length > 0) {
			var viewFullscreenMapHref = $('a#viewfullscreenmap').attr('data-basehref');
			$('a#viewfullscreenmap').attr('href',viewFullscreenMapHref);
		}

		$('#enable-streetview').text('Show me on Street View');
	}

	map.fitBounds(mapBounds);

	$('#zoom-position').removeClass('zoomedin');
	if ($('#zoom-position').hasClass('app-zoom-position')) {
		$('#zoom-position').html('Zoom&nbsp;in&nbsp;to<br />position');
	}
	else {
		$('#zoom-position').html('Zoom in to position');
	}
}


window.getWeatherConditions = (customLat,customLng) => {
	var targetLatLng = getTargetLatLng(customLat,customLng);

	if (targetLatLng) {
		const params = {
			lat: targetLatLng.lat().toString(),
			lng: targetLatLng.lng().toString()
		};

		$.post("/default/ajax?ajax=get_weather_conditions", params)
			.done(function(weatherData) {
				const $wrapper = $('.weather-conditions');
				if (!weatherData.success){
					$wrapper.hide();
					return;
				}
				$wrapper.find(".bi use").attr("xlink:href", weatherData.svgicon); // need to use attr, prop doesn't work
				$wrapper.find(".temperature-celsius").html(weatherData.temperature_celsius);
				$wrapper.find(".temperature-fahrenheit").html(weatherData.temperature_fahrenheit);
				$wrapper.find(".address-inner").attr('href',weatherData.googlesearch);
				$wrapper.find(".address-inner").html(weatherData.address + '&nbsp;&nbsp;<svg class="bi" width="13px" height="13px" fill="currentColor"  viewBox="0 0 13 13"><use xlink:href="/public/icons/bootstrap-icons.svg#box-arrow-up-right" /></svg>');
				$wrapper.find(".date").text(weatherData.date);
				$wrapper.find(".date-short").text(weatherData.date_short);
				$wrapper.find(".time").text(weatherData.time);

				$wrapper.find(".weather-conditions-loading").hide();
				$wrapper.find(".weather-conditions-result").css('visibility', 'visible');
			})
			.fail(function () {
				// TODO show message insead of spinner
			});
	}
}


function getTargetLatLng(customLat,customLng) {
	if (typeof customLat != 'undefined' && typeof customLng != 'undefined') {
		return new google.maps.LatLng(customLat,customLng);
	}
	if (typeof userMarkerLocation != 'undefined') {
		return userMarkerLocation;
	}
	if (typeof pathpushTravelled != 'undefined' && pathpushTravelled.length > 0) {
		return pathpushTravelled[pathpushTravelled.length-1];
	}

	// Returns either google.maps.LatLng or undefined
	return startMarkerPosition;
}